import { render, staticRenderFns } from "./Simucase.vue?vue&type=template&id=e4a75bba"
import script from "./Simucase.vue?vue&type=script&lang=js"
export * from "./Simucase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports